<!--
 * @Author: renming-lj 2982488597@qq.com
 * @Date: 2024-05-13 16:46:25
 * @LastEditors: renming-lj 2982488597@qq.com
 * @LastEditTime: 2024-06-06 14:27:47
 * @FilePath: \program_admin\src\views\home\index.vue
 * @Description: 首页
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="home">
    <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" :collapse="isCollapse" router text-color="#ffffff" background-color="#000000">
      <div class="logo">
        <div v-if="list.logo.type == 'text'">成语歇后语study 后台</div>
        <img class="img" v-else-if="list.logo.type == 'img'" :src="list.logo.url" alt="" />
      </div>
      <el-menu-item v-for="item in list.menu" :index="item.path" :key="item.id" :disabled="item.disabled">
        <el-icon>
          <IconMenu v-if="item.icon == 'IconMenu'" />
          <User v-if="item.icon == 'User'" />
          <Notebook v-if="item.icon == 'Notebook'" />
          <ChatDotRound v-if="item.icon == 'ChatDotRound'" />
        </el-icon>
        <template #title>{{ item.title }}</template>
      </el-menu-item>
    </el-menu>
    <div class="home-right">
      <div class="right-header">
        <div class="right-header-left">
          <el-radio-group v-model="isCollapse">
            <el-icon @click="foldClick(false)" :value="false" size="20" class="icon" color="#666666" v-if="isCollapse">
              <Expand />
            </el-icon>
            <el-icon @click="foldClick(true)" :value="true" size="20" class="icon" color="#666666" v-else>
              <Fold />
            </el-icon>
          </el-radio-group>
        </div>
        <div class="right-header-right">
          <el-icon size="15" class="icon" color="#666666" @click="fullScreen" v-if="!isFullScreen">
            <FullScreen />
          </el-icon>
          <el-icon size="15" class="icon" color="#666666" @click="exitFullscreen" v-else>
            <FullScreen />
          </el-icon>
          <el-dropdown @command="handleCommand">
            <el-image :src="info.avatar" class="avatar" />
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="1">个人中心</el-dropdown-item>
              </el-dropdown-menu>
              <el-dropdown-menu>
                <el-dropdown-item command="2">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-icon size="18" class="user" color="#666666" @click="user">
            <setting />
          </el-icon>

        </div>
      </div>
      <div class="right-main">
        <router-view />
      </div>
    </div>
    <!-- 设置 抽屉 -->
    <el-drawer v-model="drawer" title="设置" :with-header="true">
      <span>设置项</span>
    </el-drawer>
  </div>
</template>

<script setup>
import { userInfo } from '@/http/api.js';
import { ref, onMounted, computed } from 'vue';
import { ElMessageBox } from 'element-plus';
import { useRouter } from 'vue-router';
import {
  Menu as IconMenu,
  Setting,
  Expand,
  Fold,
  FullScreen,
  User,
  Notebook,
  ChatDotRound,
} from '@element-plus/icons-vue';

const list = ref({
  logo: {
    type: 'text', // img --- 图片 text --- 文字
    url: '',
    text: 'logo'
  },
  menu: [
    {
      id: 1,
      path: '/index',
      title: '首页',
      icon: 'IconMenu',
      disabled: false,
    },
    {
      id: 2,
      path: '/idiom',
      title: '成语管理',
      icon: 'Notebook',
      disabled: false,
    },
    {
      id: 3,
      path: '/saying',
      title: '歇后语管理',
      icon: 'Notebook',
      disabled: false,
    },
    {
      id: 4,
      path: '/feedback',
      title: '反馈管理',
      icon: 'ChatDotRound',
      disabled: false,
    },
    {
      id: 5,
      path: '/user',
      title: '用户管理',
      icon: 'User',
      disabled: false,
    }
  ]
});

const activeIndex = ref('/index');
activeIndex.value = localStorage.getItem('currentPath');
const router = useRouter();

const info = ref({});
const isCollapse = ref(false);
const screenWidth = ref(null);
const isFullScreen = ref(false);
const drawer = ref(false);

onMounted(() => {
  // 判断侧边栏是否展开
  const init = () => {
    screenWidth.value = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (screenWidth.value <= 1000) {
      isCollapse.value = true;
    } else {
      isCollapse.value = false;
    }
    let token = JSON.parse(localStorage.getItem('token'));
    if (token.permission == '2') {
      list.value.menu[4].disabled = true;
    } else {
      list.value.menu[4].disabled = false;
    }

  }
  init();
  window.onresize = () => {
    return (() => {
      init();
    })()
  }
})

// 全屏
const fullScreen = () => {
  let element = document.documentElement;
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.webkitRequestFullScreen) {
    element.webkitRequestFullScreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    // IE11
    element.msRequestFullscreen();
  }
  isFullScreen.value = true;
}
// 退出全屏并做兼容性处理
const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) { // Firefox
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) { // IE/Edge
    document.msExitFullscreen();
  }
  isFullScreen.value = false;
};

// 侧边栏
const foldClick = (e) => {
  if (e) {
    isCollapse.value = true;
  } else {
    isCollapse.value = false;
  }
}

// 设置
const user = () => {
  drawer.value = true;
}

// 头像下拉菜单
const handleCommand = (e) => {
  if (e == '1') {
    router.push('/personal');
  } else if (e == '2') {
    ElMessageBox.alert('是否确认退出？', '提示', {
      confirmButtonText: '是',
      cancelButtonText: '否',
      showClose: false,
      showCancelButton: true,
      callback: (e) => {
        if (e == 'confirm') {
          localStorage.removeItem('token');
          router.push('/login');
        }
      },
    })
  }
}



// 用户信息接口
const userInfos = async () => {
  let token = JSON.parse(localStorage.getItem('token'));
  let { data } = await userInfo({ id: token.id });
  if (data === 4000 || data === 4004) {
    router.push('/login');
  } else {
    info.value = data[0];
  }
}

userInfos();
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  height: 100vh;
  display: flex;

  .el-menu-vertical-demo {
    background: #304156;
    color: #ffffff;

    &:not(.el-menu--collapse) {
      width: 200px;
      min-height: 400px;
    }

    .logo {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 0 10px;

      .img {
        width: auto;
        height: 100%;
      }
    }
  }

  .home-right {
    flex: 1;

    .right-header {
      width: 100%;
      height: 50px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #cccccc;

      .right-header-left {
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 15px;

        .icon {
          cursor: pointer;
        }
      }

      .right-header-right {
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-right: 15px;

        .icon {
          cursor: pointer;
          margin-right: 20px;
        }

        .user {
          cursor: pointer;
          margin-left: 20px;
        }

        .avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
      }
    }

    .right-main {
      box-sizing: border-box;
      padding: 10px
    }
  }
}
</style>
